import styled from 'styled-components/macro';

export const HorizontalLine = styled.div({
  height: 1,
  marginTop: 30,
  marginBottom: 30,
  backgroundColor: '#d5d5d5'
});
